import { render, staticRenderFns } from "./initialsAvatar.vue?vue&type=template&id=2461146a&scoped=true&lang=pug"
import script from "./initialsAvatar.vue?vue&type=script&lang=js"
export * from "./initialsAvatar.vue?vue&type=script&lang=js"
import style0 from "./initialsAvatar.vue?vue&type=style&index=0&id=2461146a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461146a",
  null
  
)

export default component.exports